import { Injectable } from '@angular/core';
import {HttpClient, HttpHeaders} from "@angular/common/http";
import {DateFormat} from "../../utils/datetime";
import {AesHelper} from "../../shared-preference/aes-helper";
import {catchError, delay, timeout} from 'rxjs/operators';
import {HttpError} from "../../utils/httpError";
import {environment} from "../../../environments/environment";
import {LoggUtilInfo} from "../../utils/loggUtil";
import {Item} from "../../inventory/model/item";
import {StringUtils} from "../../utils/string-utils";
import {SharedPreference} from '../../shared-preference/shared-perference';

@Injectable({
  providedIn: 'root'
})
export class ApiService {

  constructor(private http: HttpClient) { }
  protected apiDomain = `https://${environment.apiDomain}`;
  protected authDomain = `https://${environment.firebase.authDomain}`;
  public static endPoint = "";

  public requestHsCode(){
    // const apiUrl = `${this.apiDomain}/api/v2/delivery/hscodes`;
    const apiUrl = `https://api.khmum-pos.com/api/v2/delivery/hscodes`;

    const httpOptions = {
      headers: ApiService.generateHeaders({
        "token": ApiService.generateToken({}),
        "content-type": "application/json"
      })
    };

    console.info(`onRequestHsCode  : `,  {"url": apiUrl});

    return this.http.get(apiUrl, httpOptions)
      .pipe(catchError(HttpError.handleError));
  }

  public requestItemCollection(storeId: string){
    const apiUrl = `${this.apiDomain}/api/v2/itemCollection`;

    const httpOptions = {
      headers: ApiService.generateHeaders({
        "token": ApiService.generateToken({id: storeId}),
        "content-type": "application/json"
      })
    };

    console.info(`onRequestItemCollection : `,  httpOptions,{"url": apiUrl});

    return this.http.get(apiUrl, httpOptions)
      .pipe(catchError(HttpError.handleError));
  }

  public addItemCollection(storeId: string, body: any){
    const apiUrl = `${this.apiDomain}/api/v2/itemCollection`;

    const httpOptions = {
      headers: ApiService.generateHeaders({
        "token": ApiService.generateToken({id: storeId}),
        "content-type": "application/json"
      })
    };

    console.info(`addItemCollection : `,  {"storeId": storeId, "url": apiUrl, "body": body});

    return this.http.post(apiUrl, body, httpOptions)
      .pipe(catchError(HttpError.handleError));
  }

  public addSubscriptionHistory(storeId: string, body: any){
    const apiUrl = `${this.apiDomain}/api/v2/store/subscription`;

    const httpOptions = {
      headers: ApiService.generateHeaders({
        "token": ApiService.generateToken({id: storeId}),
        "content-type": "application/json"
      })
    };

    console.info(`onRequestItemCollection : `,  {storeId, "url": apiUrl, body});

    return this.http.post(apiUrl, body, httpOptions)
      .pipe(catchError(HttpError.handleError));
  }

  public requestSubscriptionHistory(storeId: string){
    const apiUrl = `${this.apiDomain}/api/v2/store/subscription`;

    const httpOptions = {
      headers: ApiService.generateHeaders({
        "token": ApiService.generateToken({id: storeId}),
        "content-type": "application/json"
      })
    };

    console.info(`onRequestSubscriptionHistory : `,  storeId, {"url": apiUrl});

    return this.http.get(apiUrl, httpOptions)
      .pipe(catchError(HttpError.handleError));
  }

  public requestReadItem(storeId: string, id: string){
    const apiItemUrl = `${this.apiDomain}/api/v2/cdn/item/${id}`;

    const httpOptions = {
      headers: ApiService.generateHeaders({
        "token": ApiService.generateToken({id: storeId, isNoTimeStamp: true}),
        "content-type": "application/json"
      })
    };

    console.info(`onRead from id:: ${id} storeId: ${storeId} : `,  {"url": apiItemUrl});

    if(!storeId)
      return this.http.get(apiItemUrl)
        .pipe(catchError(HttpError.handleError));

    return this.http.get(apiItemUrl, httpOptions)
      .pipe(catchError(HttpError.handleError));
  }

  public downloadSaleReport(storeId: string, status: string, currencyType: string = 'USD', conversionRate: number = 1, startDate: string, endDate: string){

    if(startDate && !endDate){
      endDate = startDate;
    }

    let apiUrl = `${this.apiDomain}/api/v2/report/sale/download?currency=${currencyType}&conversionRate=${conversionRate}&startDate=${startDate}&endDate=${endDate}&storeId=${storeId}&status=${status}`;

    const uid = SharedPreference.getUser().uid;
    if(SharedPreference.getUser().userAccessExclude && SharedPreference.getUser().userAccessExclude.includes("Show All Sales Report"))
      apiUrl = apiUrl + `&uid=${uid}`;

    console.info(`onRead from storeId: ${storeId} : `,  {"url": apiUrl});
    return this.http.get(apiUrl, {
        observe: 'response',
        responseType: 'blob' as 'json',
        headers: ApiService.generateHeaders({
          "token": ApiService.generateToken({}),
          "content-type": "application/json"
        })
    });
  }

  public requestSaleReport(storeId: string, startDate: string, endDate: string){
    let apiUrl = `${this.apiDomain}/api/v2/report/sale/details/dataSummaryByDate?storeId=${storeId}&startDate=${startDate}&endDate=${endDate}`;

    const uid = SharedPreference.getUser().uid;
    if(SharedPreference.getUser().userAccessExclude && SharedPreference.getUser().userAccessExclude.includes("Show All Sales Report"))
      apiUrl = apiUrl + `&uid=${uid}`;

    console.info(`onRead from storeId: ${storeId} : `,  {"url": apiUrl});
    return this.http.get(apiUrl, {
      headers: ApiService.generateHeaders({
        "token": ApiService.generateToken({}),
        "content-type": "application/json"
      })
    });
  }

  public requestInventoryStock(storeId: string = '200324035600', from: string = '1620039264', to: string = '1622717664'){
    const apiStockUrl = `${this.apiDomain}/api/v2/stock?from=${from}&to=${to}`;

    const httpOptions = {
      headers: ApiService.generateHeaders({
        "token": ApiService.generateToken({id: storeId}),
        "content-type": "application/json"
      })
    };

    console.info(`onRead from storeId: ${storeId} : `,  {"url": apiStockUrl});

    return this.http.get(apiStockUrl, httpOptions)
      .pipe(catchError(HttpError.handleError));
  }

  public requestStoresList({type = 'expiring', days = 7, platform = 'all', enable = 'all', startDate = null, endDate = null} = {}){
    let apiUrl = `${this.apiDomain}/api/v2/store?type=${type}&platform=${platform}&enable=${enable}`;
    apiUrl += startDate && endDate
      ? `&startDate=${StringUtils.getDateToISOString(startDate + ' 00:00:00.000')}&endDate=${StringUtils.getDateToISOString(endDate + ' 23:59:59.999')}`
      : `&days=${days}`;

    const httpOptions = {
      headers: ApiService.generateHeaders({
        "token": ApiService.generateToken({}),
        "content-type": "application/json"
      })
    };

    console.info(`onRead ${type} stores list : `,  {"url": apiUrl});

    return this.http.get(apiUrl, httpOptions)
      .pipe(catchError(HttpError.handleError));
  }

  public requestSearchOrder(keyword: string){
    const apiUrl = `${this.authDomain}/order/search?keyword=${keyword}`;

    const httpOptions = {
      headers: ApiService.generateHeaders({
        "token": ApiService.generateToken({}),
        "content-type": "application/json"
      })
    };

    console.info(`onRead from id:: ${keyword} : `,  {"url": apiUrl});

    return this.http.get(apiUrl, httpOptions)
      .pipe(catchError(HttpError.handleError));
  }

  public requestFilterByBrandAndCategory(isBrand: boolean = true, id: string){
    const doc = isBrand ? 'brand' : 'category';
    const apiItemUrl = `${this.apiDomain}/api/v2/related?${doc}=${id}`;

    const httpOptions = {
      headers: ApiService.generateHeaders({
        "content-type": "application/json"
      })
    };

    console.info(`onRead from id: ${id} : `,  {"url": apiItemUrl});

    return this.http.get(apiItemUrl, httpOptions)
      .pipe(catchError(HttpError.handleError));
  }

  public requestCompositions(data: any){
    const apiUrl = `${this.apiDomain}/api/v2/cdn/item/compositions`;
    const httpOptions = {
      headers: ApiService.generateHeaders({
        "token": ApiService.generateToken({}),
        "content-type": "application/json"
      })
    };

    console.info(`requestCompositions ==> : `,  {"url": apiUrl, "data": data});

    return this.http.post(apiUrl, data, httpOptions)
      .pipe(catchError(HttpError.handleError));
  }

  public requestCompositionsInUse(itemId: string, barcode: string){
    const apiUrl = `${this.apiDomain}/api/v2/cdn/item/${itemId}/${barcode}/compositions/checkinuse`;
    const httpOptions = {
      headers: ApiService.generateHeaders({
        "token": ApiService.generateToken({}),
        "content-type": "application/json"
      })
    };

    console.info(`requestCompositions ==> : `,  {"url": apiUrl, "token": ApiService.generateToken({})});

    return this.http.post(apiUrl, undefined, httpOptions)
      .pipe(catchError(HttpError.handleError));
  }

  public requestReadItemAdmin({storeId = null, lastId = null, keyword = null, enable = null, saleType = null, brandId = null, categoryId = null, ranking = null, isExpired = null, collections = null} = {}){

    let url = `${this.apiDomain}/api/v2/item?store=${storeId}`;

    if(lastId !== null && lastId !== '') {
      url = url + `&lastid=${lastId}`;
    } else {
      url = url + `&ts=${DateFormat.getTimeStamp()}`;
    }

    if(keyword !== null && keyword !== '')
      url = url + `&search=${keyword}`;

    if(enable !== null && enable.toString() !== '')
      url = url + `&enable=${enable}`;

    if(saleType !== null && !saleType.includes('' || null))
      url = url + `&saletype=${saleType}`;

    if(brandId !== null && brandId !== '')
      url = url + `&brand=${brandId}`;

    if(categoryId !== null && categoryId !== '')
      url = url + `&category=${categoryId}`;

    if(ranking !== null && ranking !== '')
      url = url + `&ranking=${ranking}`;

    if(isExpired !== null && isExpired !== '')
      url = url + `&expire=${isExpired}`;

    if(collections !== null && !collections.includes('' || null)){
      url = url + `&collections=${collections}`;
    }

    const httpOptions = {
      headers: ApiService.generateHeaders({
        "token": ApiService.generateToken({}),
        "content-type": "application/json"
      })
    };

    console.info(`requestReadItemAdmin from storeId: ${storeId} : `,  {"url": url});

    return this.http.get(url, httpOptions)
      .pipe(catchError(HttpError.handleError));
  }

  public requestExportItemLabel(url: string, storeId: string){
    url = url + "&token=" + encodeURIComponent(ApiService.generateToken({}));
    console.info(`requestExportItemLabel from storeId: ${storeId} : `,  {"url": url});

    if(url){
      return this.http.get(url, {responseType: 'blob' as 'json'})

        .pipe(catchError(HttpError.handleError));
    }
  }

  public requestFilterItem(storeId: string = null, keyword: string = null, lastId: string = null, enable: boolean = null, saleType: string[] = null, brandId: string = null, categoryId: string = null, ranking: string = null, isExpired = null){

    let url = `${this.apiDomain}/api/v2/cdn/items?`;

    if(lastId !== null && lastId !== '')
      url = url + `&lastid=${lastId}`;

    if(keyword !== null && keyword !== '')
      url = url + `&search=${keyword}`;

    if(enable !== null && enable.toString() !== '')
      url = url + `&enable=${enable}`;

    if(saleType !== null && !saleType.includes('' || null))
      url = url + `&saletype=${saleType}`;

    if(brandId !== null && brandId !== '')
      url = url + `&brand=${brandId}`;

    if(categoryId !== null && categoryId !== '')
      url = url + `&category=${categoryId}`;

    if(ranking !== null && ranking !== '')
      url = url + `&ranking=${ranking}`;

    if(isExpired !== null && isExpired !== '')
      url = url + `&expire=${isExpired}`;

    const httpOptions = {
      headers: ApiService.generateHeaders({
        "token": ApiService.generateToken({}),
        "content-type": "application/json"
      })
    };

    console.info(`requestFilterItem from storeId: ${storeId} : `,  {"url": url});

    return this.http.get(url, httpOptions)
      .pipe(catchError(HttpError.handleError));
  }

  public requestCreateItem(data){
    const apiItemUrl = `${this.apiDomain}/api/v2/item`;

    const httpOptions = {
      headers: ApiService.generateHeaders({
        "token": ApiService.generateToken({}),
        "content-type": "application/json"
      })
    };

    console.info(`onCreate to storeId: ${data.storeId} ==> data : `,  {"url": apiItemUrl, "data": data});

    return this.http.post(apiItemUrl, data, httpOptions)
      .pipe(catchError(HttpError.handleError));
  }

  public requestUpdateItem(id: string = null, data){
    const apiItemUrl = `${this.apiDomain}/api/v2/item`;

    const httpOptions = {
      headers: ApiService.generateHeaders({
        "token": ApiService.generateToken({id: id, storeId: data.storeId}),
        "content-type": "application/json"
      })
    };

    console.info(`onUpdate to id ${id} storeId: ${data.storeId} ==> data : `,  {"url": apiItemUrl, "data": data});
    return this.http.post(apiItemUrl, data, httpOptions)
      .pipe(catchError(HttpError.handleError));
  }

  public requestCustomToken(phone: string = null, code: string = '+855'){
    const apiUrl = `${this.apiDomain}/api/v2/createToken`;
    const httpOptions = {
      headers: ApiService.generateHeaders({
        "token": ApiService.generateToken({phone}),
        "content-type": "application/json"
      })
    };

    const data = {
      code,
      phone
    };

    console.info(`requestCustomToken : `,  {"url": apiUrl, "data": data});
    return this.http.post(apiUrl, data, httpOptions)
      .pipe(catchError(HttpError.handleError));
  }

  public requestAuthOTP(phone: string = null, countryCode: string = '+855'){
    const apiUrl = `${this.apiDomain}/api/v2/auth/otp`;
    const httpOptions = {
      headers: ApiService.generateHeaders({
        "token": ApiService.generateToken({phone}),
        "content-type": "application/json"
      })
    };

    const data = {
      countryCode,
      phone
    };

    console.info(`requestAuthOTP : `,  {"url": apiUrl, "data": data});
    return this.http.post(apiUrl, data, httpOptions)
      .pipe(catchError(HttpError.handleError));
  }

  private static generateHeaders(headers = {}){
    try {
      return new HttpHeaders({
        ...headers,
        "deviceinfo": "web",
        "currenttime": new Date().getTime().toString(),
        "uid": SharedPreference.getUser() && SharedPreference.getUser().uid || "guest"
      });
    }catch (e) {
      console.error(`generateHeader : `,  e);
      return null;
    }
  }

  private static generateToken(
    {
      id = null, 
      storeId = null, 
      isNoTimeStamp = false, 
      expirationInSec = 6000, 
      isDelete = false , 
      barcodes = [], 
      isGetAllItem = false, 
      orderId = null, 
      cashier = null,
      phone = null
    }) {

    try {
      let expirationTimestamp = DateFormat.getTimeStamp(expirationInSec);

      let headerData = {
        "id": id || true,
        "expiration": isNoTimeStamp ? '' : expirationTimestamp
      };

      if(storeId){
        headerData["storeid"] = storeId;
      }

      if(orderId){
        headerData["orderid"] = orderId;
      }

      if(orderId){
        headerData["cashier"] = cashier;
      }
      
      if(phone){
        headerData["phone"] = phone;
      }

      if(isDelete){
        if (barcodes && barcodes.length > 0){
          headerData['barcodes'] = barcodes;
        } else {
          headerData['barcodes'] = [];
        }
      }

      if(isGetAllItem){
        headerData['size'] = "null";
      }

      return AesHelper.encrypt(JSON.stringify(headerData));
    }catch (e) {
      return null;
    }
  }


  public requestLowInventory(storeId : string){

    const url = `${this.apiDomain}/api/v2/inventory?store=${storeId}`;

    const httpOptions = {
      headers: ApiService.generateHeaders({
        "token": ApiService.generateToken({}),
        "content-type": "application/json"
      })
    };

    LoggUtilInfo.loggingInfo("Request lowinventory", url);
    return this.http.get(url, httpOptions)
      .pipe(
        catchError(HttpError.handleError)
      ).toPromise().then(value => {
        let itemStocks = [];
        console.log("Result request lowinventory", value);
        if(value['code'] === 200){
          itemStocks = Array.from(value['result']['data']);
          return itemStocks;
        }
        return itemStocks;
      });
  }

  public requestDeleteItem(id : string, barcodes : string[]){

    const apiItemUrl = `${this.apiDomain}/api/v2/item`;
    const httpOptions = {
      headers: ApiService.generateHeaders({
        "token": ApiService.generateToken({id: id,expirationInSec: undefined, isDelete: true, barcodes: barcodes}),
        "content-type": "application/json",
      })
    };

    console.info(`onDelete item id : ${id} ==> barcodes : `,  {"url": apiItemUrl, "barcodes": barcodes});
    return this.http.delete(apiItemUrl, httpOptions)
      .pipe(catchError(HttpError.handleError));
  }

  public requestReadAllItem(storeId: string){
    const token = ApiService.generateToken({expirationInSec: undefined, isGetAllItem: true});
    const apiItemUrl = `${this.apiDomain}/api/v2/item?store=${storeId}&token=${encodeURIComponent(token)}`;

    console.info(`onRead from storeId: ${storeId} : `,  {"url": apiItemUrl});

    return this.http.get(apiItemUrl)
      .pipe(
        catchError(HttpError.handleError)
      );
  }

  public requestUpdateItemDiscountByBrandOrCategory(id: string, data: any){
    const brandDiscountEndpoint = `${this.apiDomain}/api/v2/discount`;

    const httpOptions = {
      headers: ApiService.generateHeaders({
        "token": ApiService.generateToken({id}),
        "content-type": "application/json"
      })
    };

    return this.http.post(brandDiscountEndpoint, data, httpOptions)
      .pipe(
        catchError(HttpError.handleError)
      );
  }

  public requestEnableDisableStore(id: string, data: any){
    const enableDisableStore = `${this.authDomain}/api/store/golive`;

    const httpOptions = {
      headers: ApiService.generateHeaders({
        "token": ApiService.generateToken({id}),
        "content-type": "application/json"
      })
    };

    return this.http.post(enableDisableStore, data, httpOptions)
      .pipe(
        catchError(HttpError.handleError)
      );
  }

  public requestImportItem(items : Item[], isNew : boolean){
    const importUrl = `${this.authDomain}/api/product/import`;
    let storeId = items[0].storeId;
    let mapItems = items.reduce((key, item) => {
      let itemObj: Map<string, any>;
      itemObj = StringUtils.objToStrMap(item.toMap(true));
      if (isNew) {
            itemObj.delete("id");
      }else{
        if (itemObj.get("id").toString().includes("'")) {
          itemObj.set("id", itemObj.get("id").split("'")[1]);
        }
      }

      if (itemObj.get("storeId").toString().includes("'")) {
        itemObj.set("storeId", itemObj.get("storeId").split("'")[1]);
        storeId = itemObj.get("storeId");
      }

      if (itemObj.get("brand").toString().includes("'") && itemObj.get("brand").split("'")[1] != undefined  && !isNaN(itemObj.get("brand").split("'")[1])) {
        itemObj.set("brand", itemObj.get("brand").split("'")[1]);
      }

      if (itemObj.get("category").toString().includes("'") && itemObj.get("category").split("'")[1] != undefined && !isNaN(itemObj.get("category").split("'")[1])) {
        itemObj.set("category", itemObj.get("category").split("'")[1]);
      }

      key.push(StringUtils.strMapToObj(itemObj));
      return key;
    }, []);

    console.info(`data upload ==>  `,  importUrl, mapItems);
    const httpOptions = {
      headers: ApiService.generateHeaders({
        "token": ApiService.generateToken({id: storeId, expirationInSec: 540}),
        "content-type": "application/json"
      })
    };
    return this.http.post(importUrl, {"items" : mapItems}, httpOptions)
      .pipe(
        catchError(HttpError.handleError)
      );
  }

  public requestCloneItem(cloneStore: string, storeIds : string[]){
    const cloneUrl = `${this.apiDomain}/api/v2/product/clone`;

    console.info(`data upload ==>  `,  cloneUrl, storeIds);
    const httpOptions = {
      headers: ApiService.generateHeaders({
        "token": ApiService.generateToken({id: cloneStore, expirationInSec: 540}),
        "content-type": "application/json"
      })
    };

    const body = {"cloneStore": cloneStore, "storeIds" : storeIds};
    return this.http.post(cloneUrl, body, httpOptions)
      .pipe(
        catchError(HttpError.handleError)
      );
  }

  public requestPlatforms(bundleId: string, storeId: string) {
    let url  = `${this.apiDomain}/api/v2/platforms`;
    if(bundleId !== null && bundleId !== '')
      url = url + `?id=${bundleId}`;

    if(storeId !== null && storeId !== '')
      url = url + `?store=${storeId}`;

    const httpOptions = {
      headers: ApiService.generateHeaders({
        "token": ApiService.generateToken({}),
        "content-type": "application/json"
      })
    };

    console.info(`requestPlatforms from storeId: ${storeId} : `,  {"url": url});

    return this.http.get(url, httpOptions)
      .pipe(catchError(HttpError.handleError));

  }

  public requestUpdateOrderStatus(id: string, storeId: string, orderId: string, body) {

    let url  = `${this.apiDomain}/api/v2/order/updateStatus`;

    const httpOptions = {
      headers: ApiService.generateHeaders({
        "token": ApiService.generateToken({id: id, storeId: storeId ,expirationInSec: 120, orderId: orderId, cashier: body.cashier}),
        "content-type": "application/json"
      })
    };


    console.info({"url": url});
    return this.http.post(url, body, httpOptions)
      .pipe(catchError(HttpError.handleError));

  }


  public requestUpdateStock(data, itemId){
    let url  = `${this.apiDomain}/api/v2/stock`;
    const httpOptions = {
      headers: ApiService.generateHeaders({
        "token": ApiService.generateToken({id: itemId}),
        "content-type": "application/json"
      })
    };

    console.info(`update stock variation id: ${data.barcode}`,  {"url": url, "itemId": itemId, "data": data});

    return this.http.post(url, data, httpOptions)
      .pipe(catchError(HttpError.handleError));
  }

  public requestUpdateTempOrderToOrder(id : string){
    let url  = `${this.authDomain}/order/payback`;
    const httpOptions = {
      headers: ApiService.generateHeaders({
        "content-type": "application/json"
      })
    };
    return this.http.post(url, JSON.stringify({"tran_id" : id, "status" : 0}), httpOptions).pipe(catchError(HttpError.handleError));
  }


}
